import { FleetManagerEdit } from "./FleetManagerEdit";
import { FleetManagerCreate } from "./FleetManagerCreate";
import { FleetManagersList } from "./FleetManagersList";
import SupervisorAccountOutlinedIcon from "@material-ui/icons/SupervisorAccountOutlined";

export default {
  icon: SupervisorAccountOutlinedIcon,
  list: FleetManagersList,
  create: FleetManagerCreate,
  edit: FleetManagerEdit,
};
